import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';


export default function Highlights() {
  return (
    <Box
      id="highlights"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        color: 'white',
        bgcolor: '#06090a',
      }}
    >
      <Container
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: 3, sm: 6 },
        }}
      >
        <Box
          sx={{
            width: { sm: '100%', md: '60%' },
            textAlign: 'center',
          }}
        >
          <Typography component="h2" variant="h3" sx={{ textAlign: 'center' }}>
            Thanks for supporting!
          </Typography>
          <Typography variant="body1" sx={{ color: 'grey.400', textAlign: 'center', mt: { xs: 2, sm: 3 } }}>
          Explore the RicoLearning Suite, offering a variety of tools crafted to support educators. All applications are available at no cost, with additional projects in development.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
